<template>
  <div class="float-right" v-if="!isFeedbackSubmited">
    <span>
      Rate this response
    </span>
    <v-btn icon v-if="loading">
      <v-progress-circular indeterminate size="16" width="2" color="primary"></v-progress-circular>
    </v-btn>

    <div v-else class="d-inline-block">
      <v-btn icon @click="sendFeedback(true)">
        <v-icon small>mdi-thumb-up-outline</v-icon>
      </v-btn>
      <v-btn icon @click="sendFeedback(false)">
        <v-icon small>mdi-thumb-down-outline</v-icon>
      </v-btn>
    </div>
  </div>

  <div class="float-right" v-else>
    <div v-if="feedbackStatus">
      You’ve rated this response good.
      <v-icon small color="#007500" style="padding-bottom: 5px">mdi-thumb-up-outline</v-icon>
    </div>

    <div v-else>
      You’ve rated this response bad.
      <v-icon small color="#C70039" style="padding-bottom: 5px">mdi-thumb-down-outline</v-icon>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'Feedback',
  props: {
    post: {
      type: Object,
      default: () => ({}),
      required: true
    }
  },
  data: () => ({
    loading: false
  }),
  computed: {
    ...mapGetters(['ticket']),
    isFeedbackSubmited () {
      return this.post.hasOwnProperty('feedback')
    },
    feedbackStatus () {
      return this.post.feedback
    }
  },
  methods: {
    ...mapActions(['reportError', 'reportSuccess', 'ticketFeedback', 'getTicket']),
    async sendFeedback (feedbackState) {
      try {
        this.loading = true

        const data = {
          ticket_mask_id: this.ticket.ticketmaskid,
          post_id: this.post.ticketpostid,
          feedback: feedbackState
        }

        const { resultmsg } = await this.ticketFeedback(data)
        await this.getTicket(this.ticket.ticketmaskid)

        this.reportSuccess(resultmsg)
      } catch (e) {
        this.reportError(e)
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped>

</style>
